import { render, staticRenderFns } from "./QSSearchGroupItem.vue?vue&type=template&id=34b0f28a&scoped=true"
import script from "./QSSearchGroupItem.vue?vue&type=script&lang=js"
export * from "./QSSearchGroupItem.vue?vue&type=script&lang=js"
import style0 from "./QSSearchGroupItem.vue?vue&type=style&index=0&id=34b0f28a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b0f28a",
  null
  
)

export default component.exports